module.exports = __webpack_public_path__ + "static/media/stylised_character.d5cec524.glb";